import { FC } from "react";
import { Input } from "../../../../../../TrueUI";
import style from "../../BillingActivityStyles.module.css";
import { TableHeaderTotalsProps } from "../TypesBillingActivityTable";
const TableHeaderTotals: FC<TableHeaderTotalsProps> = ({
  billingActivityTotals,
}) => {
  return (
    <div className={style.table_header_total_inputs_container}>
      {billingActivityTotals?.map((billingActivityTotal) => (
        <Input
          id={billingActivityTotal.label}
          name={billingActivityTotal.label}
          label={billingActivityTotal.label}
          readOnly
          value={billingActivityTotal.value}
          labelPosition={"start"}
          className={style.table_header_total_input}
        />
      ))}
    </div>
  );
};
export default TableHeaderTotals;
